import { useEffect, useState } from 'react'

import { createAuthRTC } from '$services/rtc/auth'

type CRTC = typeof createAuthRTC

export const useCreateAuthRTC = () => {
  const [authRTC, setAuthRTC] = useState<ReturnType<CRTC>>()

  const reCreate = (...args: Parameters<CRTC>) => {
    const rtc = createAuthRTC(...args)

    setAuthRTC(rtc)

    return rtc
  }

  useEffect(() => {
    return () => {
      authRTC?.close()
    }
  }, [authRTC])

  return [authRTC, reCreate] as const
}

export default useCreateAuthRTC
